import { shouldReduceMotion } from '@theme/utilities';

const TILT_MAX_DEGREES = 8;

/**
 * @param {HTMLElement} mediaEl
 */
function initTiltEffect(mediaEl) {
  if (shouldReduceMotion()) return;

  /** @type {number | null} */
  let frameId = null;

  /**
   * @param {number} rotateX
   * @param {number} rotateY
   */
  function applyTransform(rotateX, rotateY) {
    mediaEl.style.transform = `perspective(50rem) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  }

  /**
   * @param {MouseEvent} event
   */
  function handleMouseMove(event) {
    const rect = mediaEl.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    if (frameId !== null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      applyTransform(-y * TILT_MAX_DEGREES, x * TILT_MAX_DEGREES);
      frameId = null;
    });
  }

  function handleMouseLeave() {
    if (frameId !== null) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
    mediaEl.style.transform = '';
  }

  mediaEl.addEventListener('mousemove', handleMouseMove);
  mediaEl.addEventListener('mouseleave', handleMouseLeave);
}

/**
 * @param {HTMLElement} sectionEl
 */
function initImageGalleryHoverEffects(sectionEl) {
  if (sectionEl.dataset.hoverEffect !== 'tilt') return;

  sectionEl.querySelectorAll('.image-gallery__media').forEach((mediaEl) => {
    if (mediaEl instanceof HTMLElement) {
      initTiltEffect(mediaEl);
    }
  });
}

document.querySelectorAll('[data-image-gallery]').forEach((sectionEl) => {
  if (sectionEl instanceof HTMLElement) {
    initImageGalleryHoverEffects(sectionEl);
  }
});
